<template>
    <div class="mt-4 mb-2">
        <div
            class="dinner-ivr-detail-text"
            v-if="details"
            v-for="(detail, index) in details"
        >
            <div class="layout row">
                <div class="mr-1  width-250">
                    {{ detail.date }}
                </div>
                <div class="">{{ detail.eventType }}</div>
            </div>
            <div class="layout row wrap mb-1 text--disabled">
                <div v-if="detail.inputDigits">
                    {{ detail.inputDigits }}
                </div>
                <div
                    v-if="
                        detail.inputDigits &&
                            detail.eventType != 'START_PAYMENT_PROCESS'
                    "
                    class="px-1"
                >
                    |
                </div>
                <div v-if="detail.eventType != 'START_PAYMENT_PROCESS'">
                    {{ detail.response }}
                </div>
            </div>
            <v-divider
                class="py-2 mb-1"
                v-if="index + 1 < details.length"
            ></v-divider>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function
    },
    data() {
        return {
            details: [],

            callActionsMap: new Map([
                ["VALIDATE_PHONE", "Validate Phone"],
                ["RECOVER_PIN", "Recover Pin"],
                ["VALIDATE_CARD", "Entered Credit Card"],
                ["VALIDATE_EXP", "Validate Expiration Date"],
                ["PLAY_RELATED_STUDENTS", "Play Related Students"],
                ["PLAY_PRIZE_MESSAGE", "Play Prize Message"],
                ["PLAY_TRACKING_INFO", "Play Tracking Info"],
                ["CHECK_AMOUNT_INPUT", "Check Amount Input"],
                ["CHECK_DONATIONS_LINE_INPUT", "Check Amount Input"],
                ["CHECK_DONATIONS_LINE_AMOUNT_INPUT", "Check Amount Input"],
                ["CHECK_SCHEDULE_AMOUNT_INPUT", "Check Schedule Amount Input"],
                ["CHECK_SCHEDULE_COUNT_INPUT", "Check Schedule Count Input"],
                ["START_PAYMENT_PROCESS", "Start Payment Process"],
                ["START_AUTOPAYSETUP_PROCESS", "Start Auto Pay Setup Process"],
                ["PAYMENT_PROCESSING", "Payment Procssing"],
                ["CARD_PROCESSED_SUCCESS", "Payment Processed Successfully"],
                ["CARD_PROCESSED_FAILED", "Payment Failed"],
                ["AUTOPAY_SETUP_FAILED", "Auto Pay Setup Failed"],
                ["AUTOPAYSETUP_SUCCESS", "Auto Pay Setup Successfull"],
                ["CONTACT_US", "Contact Us"]
            ])
        };
    },
    async created() {
        await this.loadDetails();
    },
    computed: {},
    methods: {
        async loadDetails() {
            const details = await this.$http.get(
                "https://dinner-compaign.azurewebsites.net/api/account/GetCallDetails?callUUID=" +
                    this.row.call_UUID
            );

            this.details = details.map(detail => {
                detail.date = moment(detail.date).format("MM/DD/YYYY h:mm:ssA");

                detail.eventType =
                    this.callActionsMap.get(detail.eventType) ||
                    detail.eventType;

                return detail;
            });
        }
    }
};
</script>
<style>
.dinner-ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
